import { getSessionRealm, getUserIdToken, hasAuthTokens, setSessionRealm } from 'services/auth';

function hasUserIdToken(): boolean {
  const idToken = getUserIdToken();
  return typeof idToken === 'string' && idToken.trim().length > 0;
}

export function isAdminAuthenticated(): boolean {
  const realm = getSessionRealm();
  if (realm === 'user') {
    return false;
  }

  const hasAdminTokens = hasAuthTokens();
  if (!hasAdminTokens) {
    return false;
  }

  if (realm == null) {
    setSessionRealm('admin');
  }

  return true;
}

export function isUserAuthenticated(): boolean {
  const realm = getSessionRealm();
  if (realm === 'admin') {
    return false;
  }

  const isAuthenticated = hasUserIdToken();
  if (!isAuthenticated) {
    return false;
  }

  if (realm == null) {
    setSessionRealm('user');
  }

  return true;
}
